 var modal = document.getElementById("imgModal");
  var img = document.getElementsByClassName("popup-img")[0];
  var modalImg = document.getElementById("imgInModal");
  var captionText = document.getElementById("caption");
  var closeBtn = document.getElementsByClassName("close")[0];

  img.onclick = function(){
    modal.style.display = "block";
    modalImg.src = this.src;
    captionText.innerHTML = this.alt;
  }

  closeBtn.onclick = function() {
    modal.style.display = "none";
  }

  modal.onclick = function(event) {
    if (event.target === modal) {
      modal.style.display = "none";
    }
  }